module.exports = __webpack_public_path__ + "img/about-card-01.c478d702.png";